<div class="camera-container">
  <div class="d-flex align-items-center justify-content-between">
    <h5 class="text-white">
      Cameras <small>({{ numberOfCameras }})</small>
    </h5>
    <i
      class="fa fa-video-camera"
      style="font-size: 20px; cursor: pointer; margin-left: 60px; color: #fff"
      title="launch video player"
      (click)="showAdHocVideo()"
    ></i>
  </div>

  <div class="filter-controls">
    <div class="btn-group btn-group-toggle" data-toggle="buttons">
      <label
        class="btn btn-primary btn-sm"
        [class.active]="selectedOption === 'building'"
        title="building"
        (click)="selectOption('building')"
        >
        <input
          type="radio"
          name="b-f-r"
          id="radio-building"
          autocomplete="off"
          [checked]="selectedOption === 'building'"
          />B
        </label>
        <label
          class="btn btn-primary btn-sm"
          [class.active]="selectedOption === 'floor'"
          title="floor"
          (click)="selectOption('floor')"
          >
          <input
            type="radio"
            name="b-f-r"
            id="radio-floor"
            autocomplete="off"
            [checked]="selectedOption === 'floor'"
            />F
          </label>
          <label
            class="btn btn-primary btn-sm"
            [class.active]="selectedOption === 'room'"
            title="room"
            (click)="selectOption('room')"
            >
            <input
              type="radio"
              name="b-f-r"
              id="radio-room"
              autocomplete="off"
              [checked]="selectedOption === 'room'"
              />R
            </label>
          </div>
          <form [formGroup]="filterForm" class="camera-list"  style="width: 120px;">
            @if (selectedOption === 'building') {
              <select
                class="form-control"
                formControlName="building"
                (change)="buildingChanged()"
                style="height: 25px; display: inline-block; padding: 0px; font-size: 12px"
                title="browse by building"
                >
                @for (building of buildingList; track building) {
                  <option [ngValue]="building">
                    {{ building.label }} ({{ building.numberCamera }})
                  </option>
                }
              </select>
            }

            @if (selectedOption === 'floor') {
              <select
                class="form-control"
                formControlName="floor"
                (change)="floorChanged()"
                style="height: 25px; display: inline-block; padding: 0px; font-size: 12px"
                title="browse by floor"
                >
                @for (floor of floorList; track floor) {
                  <option [ngValue]="floor">
                    {{ floor.label }} ({{ floor.numberCamera }})
                  </option>
                }
              </select>
            }

            @if (selectedOption === 'room') {
              <select
                class="form-control"
                formControlName="room"
                (change)="roomChanged()"
                style="height: 25px; display: inline-block; padding: 0px; font-size: 12px"
                title="browse by room"
                >
                @for (room of roomList; track room) {
                  <option [ngValue]="room">
                    {{ room.label }} ({{ room.numberCamera }})
                  </option>
                }
              </select>
            }
          </form>
        </div>
        <div class="col-lg-12 mb-2 incident-search-wrapper">
          <input
            id="searchinput"
            class="listSearch form-control"
            type="text"
            [(ngModel)]="searchQuery"
            (input)="filterCameras()"
            placeholder="Search camera"
            autofocus
            />
          </div>

          <div class="custom-scroll v2">
            <table class="table table-striped table-hover custom-table">
              <tbody>
                @for (camera of filteredCameras; track camera) {
                  <tr>
                    <td>
                      <div class="camera-info">
                        <div class="camera-header">
                          <span class="camera-name" [title]="camera.label">
                            {{ camera.labelShort }}
                          </span>
                          <div class="camera-actions">
                            <i
                              class="fa fa-building"
                              (click)="viewPerimeter(camera)"
                              title="show camera location"
                            ></i>
                            <i
                              class="fa fa-info"
                              (click)="viewInfo(camera)"
                              title="camera info"
                            ></i>
                            <i
                              class="fa fa-video-camera"
                              (click)="playVideo(camera)"
                              title="view live video"
                            ></i>
                          </div>
                        </div>
                        <div class="camera-details">
                          <span
                            class="building"
                            [title]="'Building: ' + (camera.building?.label || '')"
                            >
                            B:{{ camera?.building?.labelShort || "" }}
                          </span>
                          <span
                            class="floor"
                            [title]="'Floor: ' + (camera.floor?.label || '')"
                            >
                            F:{{ camera?.floor?.number || "" }}
                          </span>
                          <span
                            class="room"
                            [title]="'Room: ' + (camera.room?.label || '')"
                            >
                            R:{{ camera?.room?.labelShort || "" }}
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
